import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/staticSeo/images/placeholder.png")